import React, { useEffect, useState } from "react";
import "./CardStyles.css";
import { fetchHomePageData } from "../fetchHomePageData";
import { MentorPanel } from "../../pages/Mentorpal/MentorPal";

export interface PanelCardProps {
  mentorPanel: MentorPanel;
  isMentorsPage: boolean;
  onClick: () => void;
}

const PanelCard = ({
  mentorPanel,
  isMentorsPage,
  onClick,
}) => {
  const { title, subtitle, mentors } = mentorPanel;
  const displayMentors = mentors.slice(0, 4);

  // State to store the fetched mentor data
  const [allMentorData, setAllMentorData] = useState([]);

  // Fetch home page data
  const data = async () => await fetchHomePageData(process.env.PATHWAYS_ORG_ID);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const homePageData = await data();
        setAllMentorData(homePageData.mentors); // Store mentor data in state
      } catch (error) {
        console.error("Failed to fetch home page data:", error);
      }
    };

    fetchData();
  }, []);

  const findMentorById = (mentor) => {
    const result = allMentorData.find((each) => each._id === mentor);
    return result;
  };



  const handleClick = (e) => {
    if (!e.target.closest(".card-bookmark-button")) {
      onClick();
    }
  };

  const handleLinkClick = (e) => {
    e.preventDefault();
    if (!e.target.closest(".card-bookmark-button")) {
      onClick();
    }
  };

  return (
    <div
      className={`card ${isMentorsPage ? "card-mentors-page" : ""}`}
      onClick={handleClick}
    >
      <h2 className="card-title">{title}</h2>
      <div className="panel-card-link" onClick={handleLinkClick}>
        <div className="panel-card-thumbnail-container">
          {displayMentors.map((mentor, index) => {
            const mentorData = findMentorById(mentor);
            return (
              mentorData && (
                <div key={index}>
                  <img
                    src={mentorData.thumbnail}
                    alt={mentorData.name}
                    className="panel-card-thumbnail"
                  />
                </div>
              )
            );
          })}
        </div>
      </div>
      <h3 className="panel-card-subtitle">{subtitle}</h3>
      {/*
    
    
      <button
        onClick={handleBookmark}
        className="card-bookmark-button"
        aria-label={isBookmarked ? "Remove Bookmark" : "Add Bookmark"}
      >
        <FontAwesomeIcon
          //icon={isBookmarked ? faBookmarkSolid : faBookmark}
          icon={isBookmarked ? faBookmark : faBookmarkSolid}
          className={`card-bookmark-icon ${isBookmarked ? "blue" : "white"}`}
        />
      </button>
      */}
    </div>
  );
};

export default PanelCard;
